var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import style from './HeaderMenuIconButton.module.scss';
export function HeaderMenuIconButton(_a) {
    var _b, _c;
    var label = _a.label, icon = _a.icon, iconHover = _a.iconHover, _d = _a.isActive, isActive = _d === void 0 ? false : _d;
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: clsx(style.imgWrapper, (_b = {}, _b[style.activeImg] = isActive, _b)), style: { width: 30, height: 30 } }, { children: [_jsx("img", { alt: label, width: 30, height: 30, src: icon, className: style.defaultImg }), _jsx("img", { alt: label, width: 30, height: 30, src: iconHover, className: style.hoverImg })] })), _jsx("div", __assign({ className: clsx(style.text, (_c = {}, _c[style.activeText] = isActive, _c)) }, { children: label }))] }));
}
